import { render } from "./DownloadView.vue?vue&type=template&id=509a0cec"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"

import "./DownloadView.vue?vue&type=style&index=0&id=509a0cec&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1d9c808fc766473613eb0f9d559345b4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__